import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import { createPinia } from "pinia";
import { createPersistedStatePlugin } from './utils/persist-plugin';

import Toast from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const pinia = createPinia();
pinia.use(createPersistedStatePlugin({ key: 'myApp', storage: sessionStorage })); // Usar sessionStorage
const appInstance = createApp(App);

const toastOptions = {
  autoClose: 4000,
  position: "bottom-center",
  pauseOnHover: true,
  closeOnClick: true,
  style: {
    width: "400px", // Establece un ancho predeterminado
  },
};

appInstance.use(Toast, toastOptions);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(pinia);
appInstance.mount("#app");
